module.exports = __webpack_public_path__ + "img/products.ece986fe.png";